import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FC, isValidElement } from 'react';

import { CustomIcon } from '../CustomIcon';
import styles from './EmptyResults.module.scss';
import { IEmptyResults } from './EmptyResults.types';

export const EmptyResults: FC<IEmptyResults> = ({
  iconProps: { icon, size = '3x' },
  title,
  body,
}) => (
  <div className={styles.container}>
    {isValidElement(icon) ? (
      icon
    ) : (
      <CustomIcon icon={icon as IconDefinition} size={size} />
    )}
    <p className={styles.title}>{title}</p>
    <p className={styles.body}>{body}</p>
  </div>
);
